// Keeps the MCP OAuth consent request alive across the login redirect (including the
// full-page Google/GitHub round trips), so the user lands back on the consent page.
const STORAGE_KEY = "oauth_request_id";

export function rememberOAuthRequest(requestId) {
    try {
        sessionStorage.setItem(STORAGE_KEY, requestId);
    } catch (e) {
        // sessionStorage can be unavailable (private mode); the query param still works
    }
}

export function pendingOAuthRequest() {
    try {
        return sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
        return null;
    }
}

export function clearOAuthRequest() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        // nothing to clear
    }
}

// Where to send the user after a successful login.
export function postLoginRoute() {
    if (pendingOAuthRequest()) {
        return {name: "OAuthConsent"};
    }
    return {name: "Dashboard"};
}
